import React from 'react'
import { Navigate } from "react-router-dom"

interface IPrivateRouteProps {
  isAuthenticated: boolean
  children: any
}

export default function PrivateRoute({ isAuthenticated, children }: IPrivateRouteProps) {
  return isAuthenticated ? children : <Navigate to="/auth/login/" />
}